import { STORAGE_KEY, STORAGE_VERSION, POLICY_VERSION, EXPIRY_MS } from './constants';

const CONSENT_ID_KEY = STORAGE_KEY + '-id';

function ensureConsentId() {
  let id = null;
  try { id = localStorage.getItem(CONSENT_ID_KEY); } catch (_) {}
  if (id) return id;
  const rand = (typeof crypto !== 'undefined' && crypto.randomUUID)
    ? crypto.randomUUID()
    : (Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
  id = 'acb_' + rand;
  try { localStorage.setItem(CONSENT_ID_KEY, id); } catch (_) {}
  return id;
}

export function getStoredConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const stored = JSON.parse(raw);
    if (stored.version !== STORAGE_VERSION) return null;
    // Re-prompt when the cookie/privacy policy version changes.
    if (stored.policy_version !== POLICY_VERSION) return null;
    if (Date.now() > stored.expires) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return stored;
  } catch (_) {
    return null;
  }
}

export function storeConsent(categories, action) {
  const consent = {
    version:        STORAGE_VERSION,
    policy_version: POLICY_VERSION,
    consent_id:     ensureConsentId(),
    timestamp:      Date.now(),
    expires:        Date.now() + EXPIRY_MS,
    language:       (document.documentElement.lang || navigator.language || 'en').slice(0, 5),
    categories:     { necessary: true, ...categories },
    action,
  };
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(consent)); } catch (_) {}
  try {
    window.dispatchEvent(
      new CustomEvent('accessproCookieConsent', { detail: consent, bubbles: true }),
    );
  } catch (_) {}
  return consent;
}

export function clearStoredConsent() {
  try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
  try {
    window.dispatchEvent(
      new CustomEvent('accessproCookieConsentWithdrawn', { bubbles: true }),
    );
  } catch (_) {}
}
